/* Velura add-ons: one-tap "Add" for accessories in the cart drawer and on product pages.
   Uses the same CartLinesUpdateEvent flow as Horizon's product form, so the drawer, the bag count
   and any open cart re-render exactly as they do for a normal add to bag. */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

async function addLine(button) {
  const row = button.closest('.vl-addon');
  const variantId = row?.querySelector('.vl-addon__variant')?.value || button.dataset.vlAddon;
  if (!variantId || button.disabled) return;
  const label = button.querySelector('.vl-addon__label');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  if (label) label.textContent = 'Adding';

  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const body = new FormData();
  body.append('id', variantId);
  body.append('quantity', '1');
  if (sectionIds.length) body.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(variantId), quantity: 1 }], promise: deferred.promise }));

  try {
    const cfg = fetchConfig('javascript', { body });
    const response = await fetch(Theme.routes.cart_add_url, { ...cfg, headers: { ...cfg.headers, Accept: 'text/html' } }).then((r) => r.json());
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    if (response.status) {
      button.dispatchEvent(new CartErrorEvent({ error: response.message || 'Could not add', code: 'INVALID', detail: { description: response.description } }));
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'velura-addons' } });
      if (label) label.textContent = 'Sold out';
      return;
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'velura-addons', itemCount: 1, sections: response.sections, didError: false },
    });
    if (label) label.textContent = 'Added';
  } catch (error) {
    deferred.reject?.(error);
    if (label) label.textContent = 'Try again';
    button.disabled = false;
  } finally {
    button.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-vl-addon]');
  if (button) addLine(button);
});
